import { api } from './base';
import { Employee } from './employee.api';

export interface SiteRole {
  id: number;
  status: number;
  site_id: number;
  name: string;
  title: string;
  description?: string;
  create_time?: string;
  modify_time?: string;
}

export interface SimpleDepartment {
  id: number;
  name: string;
  path: string;
}

export interface RoleMembers {
  departments: Array<SimpleDepartment>;
  employees: Array<Employee>;
}

export interface RoleMemberModify {
  siteId: number;
  roleId: number;
  checked: boolean;
  employeeId?: number;
  departmentId?: number;
}

export const siteAdminRoleApis = {
  async getRoles(siteId: number, roleType: number): Promise<Array<SiteRole>> {
    const result = await api.get(`/admin/sites/${siteId}/roles/${roleType}`);
    return result.roles;
  },
  async saveRole(role: SiteRole, roleType: number): Promise<SiteRole> {
    let result: any;
    if (role.id) {
      result = await api.put(`/admin/sites/${role.site_id}/roles/${role.id}`, role);
    } else {
      result = await api.post(`/admin/sites/${role.site_id}/roles/${roleType}`, role);
    }
    return result.role;
  },
  async deleteRole(siteId: number, roleId: number) {
    await api.delete(`/admin/sites/${siteId}/roles/${roleId}`);
  },
  getRoleMembers(siteId: number, roleId: number) {
    return api.get<RoleMembers>(`/admin/sites/${siteId}/roles/${roleId}/members`);
  },
  updateRoleMember(modify: RoleMemberModify) {
    return api.post<RoleMembers>(`/admin/sites/${modify.siteId}/roles/${modify.roleId}/members`, [
      {
        checked: modify.checked,
        employee_id: modify.employeeId,
        department_id: modify.departmentId
      }
    ]);
  }
};

export const roleType: { [key: string]: number } = {
  perm_role: 0,
  grant: 0,
  perm: 0
};
